import { createSelector } from 'reselect';
import { isAdviserArea } from '../../CommonSelectors/CommonAreaSelector';
import { EXTERNAL_HOST } from '../../ConsumerArea/ConsumerAreaConstants';
import { externalHostSelector, isConsumerArea } from '../../ConsumerArea/ConsumerAreaSelector';

export const goalsSummaryState = state => state.GoalsSummary;

export const hasLoaded = createSelector(goalsSummaryState, goalsSummary => goalsSummary.hasLoaded);

export const goalsList = createSelector(goalsSummaryState, goalsSummary => goalsSummary.goals);

export const showAddGoalSelector = createSelector(
  isConsumerArea,
  isAdviserArea,
  externalHostSelector,
  (isConsumer, isAdvisor, externalHost) => {
    if (ADV.entities.isOptedIn('EditFinancialPlan')) {
      if (isAdvisor) {
        return true;
      }

      if (isConsumer && externalHost !== EXTERNAL_HOST.FTCI) {
        return true;
      }
    }

    return false;
  },
);

export const selectEstatePlanningGoalSummary = createSelector(goalsList, goals =>
  goals.find(goal => goal.GoalType === 'estatePlanning'),
);
